import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./Header/Header";

const GuestLayout = () => {
  const navigate = useNavigate();

  const handleClickCapture = (e) => {
    const target = e.target;
    const isInteractive =
      target.closest("button") ||
      target.closest("a") ||
      target.closest('[role="button"]') ||
      target.closest('[role="tab"]') ||
      target.closest('[role="option"]') ||
      target.closest("input") ||
      target.closest("select") ||
      target.closest("textarea") ||
      target.closest(".leaflet-interactive") ||
      target.closest(".recharts-wrapper") ||
      target.closest(".apexcharts-canvas");

    if (isInteractive) {
      e.stopPropagation();
      e.preventDefault();
      navigate("/login");
    }
  };

  return (
    <>
      <header>
        <Header />
      </header>

      <Box
        pt="1.5rem"
        sx={{
          mt: { xs: "56px", sm: "64px" },
          px: { xs: "1rem", md: "1.5rem" },
          overflow: "hidden",
          minHeight: "calc(100vh - 130px)",
        }}
        onClickCapture={handleClickCapture}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default GuestLayout;
